import store from 'store'

const Page = {
  view() {
    const { profile } = store.getState().user
    const { preferredName: name } = profile
    return m('div'
      , m('h2', `Hi ${name}!`)
      , m('p', `Don't forget your xyz for this Sunday! (Because we know you're in cast)`)
      , m('p', '(Authorised and spoken by Daniella Taglieri on behalf of Camberwell Showtime, Camberwell)')
      , m('p', `Might get a message from Chris instead if you're in Personnel, etc`)
      , m('div'
        , m('h4', 'Downloads')
        , m('div', m('button', { class: 'btn' }, 'Music'))
        , m('div', m('button', { class: 'btn' }, `Prod notes (because we know you're in prod team)`))
        , m('div', m('button', { class: 'btn' }, `Sheet music (because we know you're in band)`))
        , m('div', m('button', { class: 'btn' }, `P&S roster (because we know you're a parent)`))
        , m('div', m('button', { class: 'btn' }, `etc`))))
  }
}

export const MainPage = Page

export default Page
